import { motion } from 'motion/react';
import { TestimonialCard } from '../components/TestimonialCard';
import { useSiteConfig } from '../utils/siteConfig';

export function Testimonials() {
  const { config } = useSiteConfig();
  const testimonials = config.testimonials;

  return (
    <div className="pt-24 bg-slate-50 min-h-screen">
      <div className="max-w-7xl mx-auto py-24 px-6">
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="px-4 py-1.5 bg-primary/5 border border-primary/20 text-primary rounded-full text-xs font-semibold uppercase tracking-wider inline-block mb-4 shadow-sm">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-6xl mb-6 text-slate-900 font-black tracking-tight heading-glow">Client Love</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed font-sans">
            Hear from the visionaries, founders, and leaders we partner with to scale digital excellence.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
            >
              {testimonial.image ? (
                <div className="p-8 rounded-3xl glass-card glass-card-hover flex flex-col h-full">
                  <div className="flex gap-1 text-primary mb-6">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  <blockquote className="text-lg text-slate-700 mb-8 flex-grow font-sans">
                    "{testimonial.quote}"
                  </blockquote>
                  <div className="flex items-center gap-4">
                    <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover bg-slate-200 shadow-sm" />
                    <div>
                      <div className="font-bold text-slate-900">{testimonial.author}</div>
                      <div className="text-sm text-slate-500">{testimonial.role} {testimonial.company && `at ${testimonial.company}`}</div>
                    </div>
                  </div>
                </div>
              ) : (
                <TestimonialCard {...testimonial} />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
